import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 7V3h-2v4h-4V3H8v4H6v7.5L9.5 18v3h5v-3l3.5-3.51V7h-2z"
}), 'PowerSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PowerSharp.js
// module id = 5595
// module chunks = 2